// 加载头部
//
require('../lib/iealert/iealert.js');
require('../lib/iealert/iealert/style.css');
$(function() {
    context.jumpToLoginIfNoMember();
    $("body").iealert();
})


$.get({ url: '/top.html', contentType: 'text/html', loading: false }).success(function(res) {
    var rootNode = $('<div>' + res + '</div>');
    rootNode.appendTo('#top')
    var vm = {
        member: ko.observable({}),
        logout: function() {
            $.get({ url: hostsetter('members/logout'), loading: false }).success(function() {
                window.location.href = '/login.html?action=login';
            })
        }
    };
    //
    context.markMemberAware(function(member) {
        vm.member(member);
    });
    //
    ko.applyBindings(vm, rootNode[0]);
    $.get(hostsetter('members/current')).success(function(member) {
        context.resolveForcefully(member);
    })
})
//
// 加载导航
var params = urlparser(window.location.href);
var categoryId = params.get('categoryId');
$.get({ url: '/nav.html', contentType: 'text/html', loading: false }).success(function(res) {
    //
    var rootNode = $('<div>' + res + '</div>');
    rootNode.appendTo('#nav');
    var vm = {
        base: '/product/',
        categoryId: +categoryId,
    };
    ko.applyBindings(vm, rootNode[0]);
    //
})
// 加载搜索
$.get({ url: '/search.html', contentType: 'text/html', loading: false }).success(function(res) {
    var rootNode = $('<div>' + res + '</div>');
    rootNode.appendTo('#search')
    var vm = {
        base: '/product/',
        count: ko.pureComputed(function() {
            return vm.carts().length;
        }, vm),
        total: ko.pureComputed(function() {
            var sum = 0;
            $.each(vm.carts(), function() {
                sum += this.amount
            })
            return sum;
        }, vm),
        search: function(model, event) {
            $(event.target).closest('form').submit();
        },
        carts: ko.observableArray([]),
        removeCart: function(cart) {
            var index = vm.carts().indexOf(cart);
            vm.carts.splice(index, 1);
            $.ajax({ url: hostsetter('carts/' + cart.id), type: 'delete', loading: false }).success(function(res) {
                context.resolveCartsForcefully(res.data);
            })
        },
        toggleCartCollapse: function() {
            context.memberOrLogin(function() {
                $(".cart").stop().toggle();
            })
        },
        Cartshow: function() {
            context.memberOrLogin(function() {
                $(".cart").show();
            })
        },
        CartsHide: function() {
            context.memberOrLogin(function() {
                $(".cart").hide();
            })
        }
    };
    //
    context.markCartAware(function(carts) {
        vm.carts($.map(carts, function(e) {
            e.scaleDesc = ko.pureComputed(function() {
                return e.modelName.split('@#@',1)[0];
            }, self)
            return e;
        }));
    });
    context.markMemberAware(function(member) {
        member && member.id && $.get(hostsetter('/carts/of/' + member.id)).success(function(carts) {
            if (carts && carts.length) {
                carts.forEach(function(c){
                    if (c.type == 'RUBBER') {
                        c.length = c.rubberLength
                    }
                })
            }
            context.resolveCartsForcefully(carts);
        })
    });
    //
    ko.applyBindings(vm, rootNode[0]);
})
//
// 加载底部
$.get({ url: '/footer.html', contentType: 'text/html', loading: false }).success(function(res) {
    var rootNode = $('<div>' + res + '</div>');
    rootNode.appendTo('#footer')
    var vm = {};
    ko.applyBindings(vm, rootNode[0]);
})
//
//



/*****************
 ** WEBPACK FOOTER
 ** ./controller/common.js
 ** module id = 108
 ** module chunks = 2 3 5 6 7 8 9 12 13 14 15 16 17 18
 **/